import { render, staticRenderFns } from "./polarized.vue?vue&type=template&id=6b9c6447&scoped=true&"
import script from "./polarized.vue?vue&type=script&lang=js&"
export * from "./polarized.vue?vue&type=script&lang=js&"
import style0 from "./polarized.vue?vue&type=style&index=0&id=6b9c6447&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c6447",
  null
  
)

export default component.exports